module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/campaign_banner_202505_sp_a8e239da9d418455c627fec281a1fd8e.png";